(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }

    connectedCallback(){
      this.sectionEl = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // ====== Detecteer Automation & Engineering pagina ======
      const path = (window.location.pathname || '').replace(/\/+$/,'');
      const isAE = /\/pages\/01-automation-engineering$/.test(path);

      if (isAE){
        document.documentElement.classList.add('ae-fix');

        const marker = document.createElement('div'); marker.setAttribute('data-header-marker','');
        this.parentNode.insertBefore(marker, this.nextSibling);

        let portal = document.getElementById('header-portal');
        if(!portal){ portal = document.createElement('div'); portal.id='header-portal'; document.body.prepend(portal); }
        portal.appendChild(this);

        const spacer = document.createElement('div'); spacer.className='header-portal-spacer';
        marker.replaceWith(spacer);

        const updateSpacer = () => {
          this.setHeaderHeight();
          const h = getComputedStyle(document.documentElement).getPropertyValue('--header-height') || (this.offsetHeight + 'px');
          spacer.style.height = h;
        };
        updateSpacer();
        this._ro = ('ResizeObserver' in window) ? new ResizeObserver(updateSpacer) : null;
        if (this._ro) this._ro.observe(this);
        window.addEventListener('resize', updateSpacer);

        const mqDesktop = window.matchMedia('(min-width: 990px)');
        const applyDesktopSticky = () => {
          if (mqDesktop.matches){
            this.headerIsAlwaysSticky = true;
            this.sectionEl?.classList.add('shopify-section-header-sticky','scrolled-past-header');
            this.sectionEl?.classList.remove('shopify-section-header-hidden');
          }
        };
        applyDesktopSticky();
        mqDesktop.addEventListener('change', applyDesktopSticky);

        const isMobile = window.matchMedia('(max-width: 989px)');
        const mainDrawer =
          this.querySelector('#Details-menu-drawer-container') ||
          this.querySelector('details.menu-drawer-container') ||
          Array.from(this.querySelectorAll('details')).find(d => d.querySelector('.menu-drawer__navigation')) || null;

        const menuSummary =
          this.querySelector('header-drawer summary') ||
          this.querySelector('summary.header__icon--menu') ||
          this.querySelector('summary[aria-controls*="menu"]');

        const getOverlay = () => (mainDrawer && (mainDrawer.querySelector('.menu-drawer__overlay') || this.querySelector('.menu-drawer__overlay'))) || null;

        if (mainDrawer && menuSummary){
          let openedAt = 0;

          const openDrawer = () => {
            if (!mainDrawer.open){
              mainDrawer.open = true;
              openedAt = performance.now();
              guardAfterOpen();
            }
          };

          const guardAfterOpen = () => {
            const ov = getOverlay();
            if (ov){
              ov.style.pointerEvents = 'none';
              setTimeout(()=>{ ov.style.pointerEvents=''; }, 600);
              const swallow = (e) => {
                if (performance.now() - openedAt < 480){
                  e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();
                } else {
                  ov.removeEventListener('click',swallow,true);
                  ov.removeEventListener('pointerdown',swallow,true);
                  ov.removeEventListener('touchend',swallow,true);
                }
              };
              ov.addEventListener('click',swallow,true);
              ov.addEventListener('pointerdown',swallow,true);
              ov.addEventListener('touchend',swallow,true);
            }
            const swallowDoc = (e) => {
              if (performance.now() - openedAt < 420){
                if (!mainDrawer.contains(e.target)){
                  e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();
                }
              } else {
                document.removeEventListener('click',swallowDoc,true);
                document.removeEventListener('pointerdown',swallowDoc,true);
                document.removeEventListener('touchend',swallowDoc,true);
              }
            };
            document.addEventListener('click',swallowDoc,true);
            document.addEventListener('pointerdown',swallowDoc,true);
            document.addEventListener('touchend',swallowDoc,true);
          };

          const manualToggle = (ev) => {
            if (!isMobile.matches) return;
            ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation?.();
            openDrawer();
          };
          menuSummary.addEventListener('click', manualToggle, true);
          menuSummary.addEventListener('touchend', manualToggle, { capture:true, passive:false });

          mainDrawer.addEventListener('toggle', ()=>{
            if (!mainDrawer.open && isMobile.matches && performance.now() - openedAt < 300){
              openDrawer();
            }
          });
        }
      }

      // ====== Standaard Dawn gedrag (alle pagina's) ======
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
      if (this.headerIsAlwaysSticky) this.sectionEl?.classList.add('shopify-section-header-sticky');
    }

    setHeaderHeight(){
      const h = (this.sectionEl?.offsetHeight || this.offsetHeight || 0);
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    }

    disconnectedCallback(){
      this.removeEventListener?.('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) window.removeEventListener('scroll', this.onScrollHandler);
      if (this._ro) this._ro.disconnect();
    }

    createObserver(){
      const target = this.sectionEl || this;
      const observer = new IntersectionObserver((entries,ob)=>{
        this.headerBounds = entries[0].intersectionRect || {};
        ob.disconnect();
      });
      observer.observe(target);
    }

    onScroll(){
      if (this.headerIsAlwaysSticky) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Mobiel: header altijd zichtbaar houden, nooit hide() aanroepen
      if (window.innerWidth <= 989) {
        if (scrollTop <= (this.headerBounds.top || 0)) {
          this.sectionEl?.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        } else {
          this.sectionEl?.classList.add('scrolled-past-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      // Desktop: standaard Dawn gedrag
      if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom || 0)) {
        this.sectionEl?.classList.add('scrolled-past-header');
        if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom || 0)) {
        this.sectionEl?.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= (this.headerBounds.top || 0)) {
        this.sectionEl?.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide(){
      this.sectionEl?.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');
      this.closeMenuDisclosure(); this.closeSearchModal();
    }
    reveal(){
      this.sectionEl?.classList.add('shopify-section-header-sticky','animate');
      this.sectionEl?.classList.remove('shopify-section-header-hidden');
    }
    reset(){
      this.sectionEl?.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate');
    }

    closeMenuDisclosure(){
      this.disclosures = this.disclosures || this.sectionEl?.querySelectorAll('header-menu') || [];
      this.disclosures.forEach((d)=>d.close());
    }
    closeSearchModal(){
      this.searchModal = this.searchModal || this.sectionEl?.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
